type SectionHeadingProps = {
  kicker: string;
  title: string;
  desc?: string;
  actionLabel?: string;
  actionHref?: string;
};

export default function SectionHeading({
  kicker,
  title,
  desc,
  actionLabel,
  actionHref,
}: SectionHeadingProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 border-b border-background-300/70 pb-5 md:mb-10 md:flex-row md:items-end md:justify-between">
      <div>
        <div className="mb-2 flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.25em] text-primary-600">
          <span className="h-2 w-2 rounded-full bg-accent-500" />
          {kicker}
        </div>
        <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{desc}</p>
        )}
      </div>
      {actionLabel && actionHref && (
        <a
          href={actionHref}
          className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          {actionLabel}
          <i className="ri-arrow-right-line" />
        </a>
      )}
    </div>
  );
}